import { CARD_TYPES } from "../../Card/constants";
import DisplayPolicy from "./DisplayPolicy";
import { DEFAULT_MAP_KEY } from "../constants";

/**
 * @class TopStoriesPolicy
 * @extends DisplayPolicy
 */
class TopStoriesPolicy extends DisplayPolicy {
    constructor(props) {
        super();
        this.policyName = "TopStoriesPolicy";
        this.contentPackage =
            props.contentPackage || props.displayPolicy?.contentPackage;
        this.viewportSmall = props.viewport === "viewportSmall";
    }

    buildCardTypesMap() {
        const viewportCheck = this.viewportSmall
            ? CARD_TYPES.TYPE_DEFAULT
            : CARD_TYPES.TYPE_LISTING_HORIZONTAL;
        const firstCard = this.contentPackage
            ? viewportCheck
            : CARD_TYPES.TYPE_FEATURED_REVERSED;
        this.cardTypesMap = new Map();
        this.cardTypesMap.set(0, firstCard);
        this.cardTypesMap.set(DEFAULT_MAP_KEY, viewportCheck);
    }
}

export default TopStoriesPolicy;
